import { Authority } from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore
const Entities = () => import('@/entities/entities.vue');

// prettier-ignore
const Business = () => import('@/entities/business/business.vue');
// prettier-ignore
const BusinessUpdate = () => import('@/entities/business/business-update.vue');
// prettier-ignore
const BusinessDetails = () => import('@/entities/business/business-details.vue');
// prettier-ignore
const UserInformation = () => import('@/entities/user-information/user-information.vue');
// prettier-ignore
const UserInformationUpdate = () => import('@/entities/user-information/user-information-update.vue');
// prettier-ignore
const UserInformationDetails = () => import('@/entities/user-information/user-information-details.vue');
// prettier-ignore
const ClientBankAccount = () => import('@/entities/client-bank-account/client-bank-account.vue');
// prettier-ignore
const ClientBankAccountUpdate = () => import('@/entities/client-bank-account/client-bank-account-update.vue');
// prettier-ignore
const ClientBankAccountDetails = () => import('@/entities/client-bank-account/client-bank-account-details.vue');
// prettier-ignore
const BusinessBankAccount = () => import('@/entities/business-bank-account/business-bank-account.vue');
// prettier-ignore
const BusinessBankAccountUpdate = () => import('@/entities/business-bank-account/business-bank-account-update.vue');
// prettier-ignore
const BusinessBankAccountDetails = () => import('@/entities/business-bank-account/business-bank-account-details.vue');
// prettier-ignore
const BusinessClientReference = () => import('@/entities/business-client-reference/business-client-reference.vue');
// prettier-ignore
const BusinessClientReferenceUpdate = () => import('@/entities/business-client-reference/business-client-reference-update.vue');
// prettier-ignore
const BusinessClientReferenceDetails = () => import('@/entities/business-client-reference/business-client-reference-details.vue');
// prettier-ignore
const Operation = () => import('@/entities/operation/operation.vue');
// prettier-ignore
const OperationUpdate = () => import('@/entities/operation/operation-update.vue');
// prettier-ignore
const OperationDetails = () => import('@/entities/operation/operation-details.vue');
// prettier-ignore
const Transaction = () => import('@/entities/transaction/transaction.vue');
// prettier-ignore
const TransactionUpdate = () => import('@/entities/transaction/transaction-update.vue');
// prettier-ignore
const TransactionDetails = () => import('@/entities/transaction/transaction-details.vue');
// prettier-ignore
const Notification = () => import('@/entities/notification/notification.vue');
// prettier-ignore
const NotificationUpdate = () => import('@/entities/notification/notification-update.vue');
// prettier-ignore
const NotificationDetails = () => import('@/entities/notification/notification-details.vue');
// prettier-ignore
const Bill = () => import('@/entities/bill/bill.vue');
// prettier-ignore
const BillUpdate = () => import('@/entities/bill/bill-update.vue');
// prettier-ignore
const BillDetails = () => import('@/entities/bill/bill-details.vue');
// prettier-ignore
const Credential = () => import('@/entities/credential/credential.vue');
// prettier-ignore
const CredentialUpdate = () => import('@/entities/credential/credential-update.vue');
// prettier-ignore
const CredentialDetails = () => import('@/entities/credential/credential-details.vue');
// prettier-ignore
const Product = () => import('@/entities/product/product.vue');
// prettier-ignore
const ProductUpdate = () => import('@/entities/product/product-update.vue');
// prettier-ignore
const ProductDetails = () => import('@/entities/product/product-details.vue');
// prettier-ignore
const Stat = () => import('@/entities/stat/stat.vue');
// prettier-ignore
const StatUpdate = () => import('@/entities/stat/stat-update.vue');
// prettier-ignore
const StatDetails = () => import('@/entities/stat/stat-details.vue');
// prettier-ignore
const Order = () => import('@/entities/order/order.vue');
// prettier-ignore
const OrderUpdate = () => import('@/entities/order/order-update.vue');
// prettier-ignore
const OrderDetails = () => import('@/entities/order/order-details.vue');
// prettier-ignore
const Channel = () => import('@/entities/channel/channel.vue');
// prettier-ignore
const ChannelUpdate = () => import('@/entities/channel/channel-update.vue');
// prettier-ignore
const ChannelDetails = () => import('@/entities/channel/channel-details.vue');
// prettier-ignore
const Message = () => import('@/entities/message/message.vue');
// prettier-ignore
const MessageUpdate = () => import('@/entities/message/message-update.vue');
// prettier-ignore
const MessageDetails = () => import('@/entities/message/message-details.vue');
// prettier-ignore
const Address = () => import('@/entities/address/address.vue');
// prettier-ignore
const AddressUpdate = () => import('@/entities/address/address-update.vue');
// prettier-ignore
const AddressDetails = () => import('@/entities/address/address-details.vue');
// prettier-ignore
const Country = () => import('@/entities/country/country.vue');
// prettier-ignore
const CountryUpdate = () => import('@/entities/country/country-update.vue');
// prettier-ignore
const CountryDetails = () => import('@/entities/country/country-details.vue');
// prettier-ignore
const City = () => import('@/entities/city/city.vue');
// prettier-ignore
const CityUpdate = () => import('@/entities/city/city-update.vue');
// prettier-ignore
const CityDetails = () => import('@/entities/city/city-details.vue');
// prettier-ignore
const SubCategory = () => import('@/entities/sub-category/sub-category.vue');
// prettier-ignore
const SubCategoryUpdate = () => import('@/entities/sub-category/sub-category-update.vue');
// prettier-ignore
const SubCategoryDetails = () => import('@/entities/sub-category/sub-category-details.vue');
// prettier-ignore
const Category = () => import('@/entities/category/category.vue');
// prettier-ignore
const CategoryUpdate = () => import('@/entities/category/category-update.vue');
// prettier-ignore
const CategoryDetails = () => import('@/entities/category/category-details.vue');
// prettier-ignore
const Sector = () => import('@/entities/sector/sector.vue');
// prettier-ignore
const SectorUpdate = () => import('@/entities/sector/sector-update.vue');
// prettier-ignore
const SectorDetails = () => import('@/entities/sector/sector-details.vue');
// prettier-ignore
const Love = () => import('@/entities/love/love.vue');
// prettier-ignore
const LoveUpdate = () => import('@/entities/love/love-update.vue');
// prettier-ignore
const LoveDetails = () => import('@/entities/love/love-details.vue');
// prettier-ignore
const ClientBase = () => import('@/entities/client-base/client-base.vue');
// prettier-ignore
const ClientBaseUpdate = () => import('@/entities/client-base/client-base-update.vue');
// prettier-ignore
const ClientBaseDetails = () => import('@/entities/client-base/client-base-details.vue');
// prettier-ignore
const Training = () => import('@/entities/training/training.vue');
// prettier-ignore
const TrainingUpdate = () => import('@/entities/training/training-update.vue');
// prettier-ignore
const TrainingDetails = () => import('@/entities/training/training-details.vue');
// prettier-ignore
const ProductCatalog = () => import('@/entities/product-catalog/product-catalog.vue');
// prettier-ignore
const ProductCatalogUpdate = () => import('@/entities/product-catalog/product-catalog-update.vue');
// prettier-ignore
const ProductCatalogDetails = () => import('@/entities/product-catalog/product-catalog-details.vue');
// prettier-ignore
const JobQueue = () => import('@/entities/job-queue/job-queue.vue');
// prettier-ignore
const JobQueueUpdate = () => import('@/entities/job-queue/job-queue-update.vue');
// prettier-ignore
const JobQueueDetails = () => import('@/entities/job-queue/job-queue-details.vue');
// prettier-ignore
const Expense = () => import('@/entities/expense/expense.vue');
// prettier-ignore
const ExpenseUpdate = () => import('@/entities/expense/expense-update.vue');
// prettier-ignore
const ExpenseDetails = () => import('@/entities/expense/expense-details.vue');
// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

export default {
  path: '/',
  component: Entities,
  children: [
    {
      path: 'business',
      name: 'Business',
      component: Business,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'business/new',
      name: 'BusinessCreate',
      component: BusinessUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'business/:businessId/edit',
      name: 'BusinessEdit',
      component: BusinessUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'business/:businessId/view',
      name: 'BusinessView',
      component: BusinessDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'user-information',
      name: 'UserInformation',
      component: UserInformation,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'user-information/new',
      name: 'UserInformationCreate',
      component: UserInformationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'user-information/:userInformationId/edit',
      name: 'UserInformationEdit',
      component: UserInformationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'user-information/:userInformationId/view',
      name: 'UserInformationView',
      component: UserInformationDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'client-bank-account',
      name: 'ClientBankAccount',
      component: ClientBankAccount,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'client-bank-account/new',
      name: 'ClientBankAccountCreate',
      component: ClientBankAccountUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'client-bank-account/:clientBankAccountId/edit',
      name: 'ClientBankAccountEdit',
      component: ClientBankAccountUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'client-bank-account/:clientBankAccountId/view',
      name: 'ClientBankAccountView',
      component: ClientBankAccountDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'business-bank-account',
      name: 'BusinessBankAccount',
      component: BusinessBankAccount,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'business-bank-account/new',
      name: 'BusinessBankAccountCreate',
      component: BusinessBankAccountUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'business-bank-account/:businessBankAccountId/edit',
      name: 'BusinessBankAccountEdit',
      component: BusinessBankAccountUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'business-bank-account/:businessBankAccountId/view',
      name: 'BusinessBankAccountView',
      component: BusinessBankAccountDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'business-client-reference',
      name: 'BusinessClientReference',
      component: BusinessClientReference,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'business-client-reference/new',
      name: 'BusinessClientReferenceCreate',
      component: BusinessClientReferenceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'business-client-reference/:businessClientReferenceId/edit',
      name: 'BusinessClientReferenceEdit',
      component: BusinessClientReferenceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'business-client-reference/:businessClientReferenceId/view',
      name: 'BusinessClientReferenceView',
      component: BusinessClientReferenceDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'operation',
      name: 'Operation',
      component: Operation,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'operation/new',
      name: 'OperationCreate',
      component: OperationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'operation/:operationId/edit',
      name: 'OperationEdit',
      component: OperationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'operation/:operationId/view',
      name: 'OperationView',
      component: OperationDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'transaction',
      name: 'Transaction',
      component: Transaction,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'transaction/new',
      name: 'TransactionCreate',
      component: TransactionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'transaction/:transactionId/edit',
      name: 'TransactionEdit',
      component: TransactionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'transaction/:transactionId/view',
      name: 'TransactionView',
      component: TransactionDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'notification',
      name: 'Notification',
      component: Notification,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'notification/new',
      name: 'NotificationCreate',
      component: NotificationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'notification/:notificationId/edit',
      name: 'NotificationEdit',
      component: NotificationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'notification/:notificationId/view',
      name: 'NotificationView',
      component: NotificationDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'bill',
      name: 'Bill',
      component: Bill,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'bill/new',
      name: 'BillCreate',
      component: BillUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'bill/:billId/edit',
      name: 'BillEdit',
      component: BillUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'bill/:billId/view',
      name: 'BillView',
      component: BillDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'credential',
      name: 'Credential',
      component: Credential,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'credential/new',
      name: 'CredentialCreate',
      component: CredentialUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'credential/:credentialId/edit',
      name: 'CredentialEdit',
      component: CredentialUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'credential/:credentialId/view',
      name: 'CredentialView',
      component: CredentialDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'product',
      name: 'Product',
      component: Product,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'product/new',
      name: 'ProductCreate',
      component: ProductUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'product/:productId/edit',
      name: 'ProductEdit',
      component: ProductUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'product/:productId/view',
      name: 'ProductView',
      component: ProductDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'stat',
      name: 'Stat',
      component: Stat,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'stat/new',
      name: 'StatCreate',
      component: StatUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'stat/:statId/edit',
      name: 'StatEdit',
      component: StatUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'stat/:statId/view',
      name: 'StatView',
      component: StatDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'order',
      name: 'Order',
      component: Order,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'order/new',
      name: 'OrderCreate',
      component: OrderUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'order/:orderId/edit',
      name: 'OrderEdit',
      component: OrderUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'order/:orderId/view',
      name: 'OrderView',
      component: OrderDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'channel',
      name: 'Channel',
      component: Channel,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'channel/new',
      name: 'ChannelCreate',
      component: ChannelUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'channel/:channelId/edit',
      name: 'ChannelEdit',
      component: ChannelUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'channel/:channelId/view',
      name: 'ChannelView',
      component: ChannelDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'message',
      name: 'Message',
      component: Message,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'message/new',
      name: 'MessageCreate',
      component: MessageUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'message/:messageId/edit',
      name: 'MessageEdit',
      component: MessageUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'message/:messageId/view',
      name: 'MessageView',
      component: MessageDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'address',
      name: 'Address',
      component: Address,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'address/new',
      name: 'AddressCreate',
      component: AddressUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'address/:addressId/edit',
      name: 'AddressEdit',
      component: AddressUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'address/:addressId/view',
      name: 'AddressView',
      component: AddressDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'country',
      name: 'Country',
      component: Country,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'country/new',
      name: 'CountryCreate',
      component: CountryUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'country/:countryId/edit',
      name: 'CountryEdit',
      component: CountryUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'country/:countryId/view',
      name: 'CountryView',
      component: CountryDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'city',
      name: 'City',
      component: City,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'city/new',
      name: 'CityCreate',
      component: CityUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'city/:cityId/edit',
      name: 'CityEdit',
      component: CityUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'city/:cityId/view',
      name: 'CityView',
      component: CityDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'sub-category',
      name: 'SubCategory',
      component: SubCategory,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'sub-category/new',
      name: 'SubCategoryCreate',
      component: SubCategoryUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'sub-category/:subCategoryId/edit',
      name: 'SubCategoryEdit',
      component: SubCategoryUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'sub-category/:subCategoryId/view',
      name: 'SubCategoryView',
      component: SubCategoryDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'category',
      name: 'Category',
      component: Category,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'category/new',
      name: 'CategoryCreate',
      component: CategoryUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'category/:categoryId/edit',
      name: 'CategoryEdit',
      component: CategoryUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'category/:categoryId/view',
      name: 'CategoryView',
      component: CategoryDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'sector',
      name: 'Sector',
      component: Sector,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'sector/new',
      name: 'SectorCreate',
      component: SectorUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'sector/:sectorId/edit',
      name: 'SectorEdit',
      component: SectorUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'sector/:sectorId/view',
      name: 'SectorView',
      component: SectorDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'love',
      name: 'Love',
      component: Love,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'love/new',
      name: 'LoveCreate',
      component: LoveUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'love/:loveId/edit',
      name: 'LoveEdit',
      component: LoveUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'love/:loveId/view',
      name: 'LoveView',
      component: LoveDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'client-base',
      name: 'ClientBase',
      component: ClientBase,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'client-base/new',
      name: 'ClientBaseCreate',
      component: ClientBaseUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'client-base/:clientBaseId/edit',
      name: 'ClientBaseEdit',
      component: ClientBaseUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'client-base/:clientBaseId/view',
      name: 'ClientBaseView',
      component: ClientBaseDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'training',
      name: 'Training',
      component: Training,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'training/new',
      name: 'TrainingCreate',
      component: TrainingUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'training/:trainingId/edit',
      name: 'TrainingEdit',
      component: TrainingUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'training/:trainingId/view',
      name: 'TrainingView',
      component: TrainingDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'product-catalog',
      name: 'ProductCatalog',
      component: ProductCatalog,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'product-catalog/new',
      name: 'ProductCatalogCreate',
      component: ProductCatalogUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'product-catalog/:productCatalogId/edit',
      name: 'ProductCatalogEdit',
      component: ProductCatalogUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'product-catalog/:productCatalogId/view',
      name: 'ProductCatalogView',
      component: ProductCatalogDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'job-queue',
      name: 'JobQueue',
      component: JobQueue,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'job-queue/new',
      name: 'JobQueueCreate',
      component: JobQueueUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'job-queue/:jobQueueId/edit',
      name: 'JobQueueEdit',
      component: JobQueueUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'job-queue/:jobQueueId/view',
      name: 'JobQueueView',
      component: JobQueueDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'expense',
      name: 'Expense',
      component: Expense,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'expense/new',
      name: 'ExpenseCreate',
      component: ExpenseUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'expense/:expenseId/edit',
      name: 'ExpenseEdit',
      component: ExpenseUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'expense/:expenseId/view',
      name: 'ExpenseView',
      component: ExpenseDetails,
      meta: { authorities: [Authority.USER] },
    },
    // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
  ],
};
